import { FilterKey } from '@studyportals/search-filters/server-side';
import { IFilterSelection } from '@studyportals/search-page-interface';

export class FilterSelection {
	private readonly ignoredFilters: readonly FilterKey[];
	public readonly selection: IFilterSelection;

	public constructor(selection: IFilterSelection, ignoredFilters: readonly FilterKey[]) {
		this.selection = {};
		this.ignoredFilters = ignoredFilters;

		this.merge(selection);
	}

	public merge(other: IFilterSelection): FilterSelection {
		for (const filterKey in other) {
			if (this.isIgnored(filterKey)) {
				continue;
			}

			this.selection[filterKey] = other[filterKey];
		}

		return this;
	}

	private isIgnored(filterKey: string): boolean {
		return this.ignoredFilters.includes(filterKey as FilterKey);
	}
}
